import { combineReducers } from "redux";
import {
  GET_ORDER_VEHICLE_LIST,
  GET_ORDER_VEHICLE_LIST_OK,
  GET_ORDER_VEHICLE_LIST_ERR,
  DO_ORDER_VEHICLE_LIST_CLEANUP,
  ADD_ORDER_VEHICLE,
  ADD_ORDER_VEHICLE_OK,
  ADD_ORDER_VEHICLE_ERR,
  EDIT_ORDER_VEHICLE,
  EDIT_ORDER_VEHICLE_OK,
  EDIT_ORDER_VEHICLE_ERR,
  DELETE_ORDER_VEHICLE,
  DELETE_ORDER_VEHICLE_OK,
  DELETE_ORDER_VEHICLE_ERR,
} from './actionTypes';

/********* LIST *********/

const defaultListState = {
  vehicles: [],
  vehiclesError: null,
  isLoadInProgress: false,
}

const List = (state = defaultListState, action) => {
  switch (action.type) {
    case GET_ORDER_VEHICLE_LIST:
      return {
        ...state,
        vehiclesError: null,
        isLoadInProgress: true,
      };

    case GET_ORDER_VEHICLE_LIST_OK: {
      // API returns vehicles directly as array
      const vehicles = Array.isArray(action.payload.response)
        ? action.payload.response
        : (action.payload.response?.vehicles || []);

      return {
        ...state,
        vehicles: vehicles,
        isLoadInProgress: false,
        vehiclesError: null,
      };
    }

    case GET_ORDER_VEHICLE_LIST_ERR:
      return {
        ...state,
        vehicles: [],
        vehiclesError: action.payload.error,
        isLoadInProgress: false,
      };

    case DO_ORDER_VEHICLE_LIST_CLEANUP:
      return { ...defaultListState };

    default:
      return state;
  }
}

/********* CRUD OPERATIONS *********/

const defaultCrudState = {
  // Add operation
  isAddInProgress: false,
  addError: null,
  addSuccess: false,

  // Update operation
  isUpdateInProgress: false,
  updateError: null,
  updateSuccess: false,

  // Delete operation
  isDeleteInProgress: false,
  deleteError: null,
  deleteSuccess: false,
}

const Crud = (state = defaultCrudState, action) => {
  switch (action.type) {
    // Add operations
    case ADD_ORDER_VEHICLE:
      return {
        ...state,
        isAddInProgress: true,
        addError: null,
        addSuccess: false,
      };

    case ADD_ORDER_VEHICLE_OK:
      return {
        ...state,
        isAddInProgress: false,
        addError: null,
        addSuccess: true,
      };

    case ADD_ORDER_VEHICLE_ERR:
      return {
        ...state,
        isAddInProgress: false,
        addError: action.payload.error,
        addSuccess: false,
      };

    // Update operations
    case EDIT_ORDER_VEHICLE:
      return {
        ...state,
        isUpdateInProgress: true,
        updateError: null,
        updateSuccess: false,
      };

    case EDIT_ORDER_VEHICLE_OK:
      return {
        ...state,
        isUpdateInProgress: false,
        updateError: null,
        updateSuccess: true,
      };

    case EDIT_ORDER_VEHICLE_ERR:
      return {
        ...state,
        isUpdateInProgress: false,
        updateError: action.payload.error,
        updateSuccess: false,
      };

    // Delete operations
    case DELETE_ORDER_VEHICLE:
      return {
        ...state,
        isDeleteInProgress: true,
        deleteError: null,
        deleteSuccess: false,
      };

    case DELETE_ORDER_VEHICLE_OK:
      return {
        ...state,
        isDeleteInProgress: false,
        deleteError: null,
        deleteSuccess: true,
      };

    case DELETE_ORDER_VEHICLE_ERR:
      return {
        ...state,
        isDeleteInProgress: false,
        deleteError: action.payload.error,
        deleteSuccess: false,
      };

    // Reset success flags after modal closes
    case GET_ORDER_VEHICLE_LIST:
      return {
        ...state,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
      };

    default:
      return state;
  }
}

export default combineReducers({
  List,
  Crud,
});